import { z } from "zod";

/* A schema for different types of geojson objects. */

export const pointSchema = z.object({
  type: z.literal("Point"),
  coordinates: z.array(z.number()),
});

export const multiPointSchema = z.object({
  type: z.literal("MultiPoint"),
  coordinates: z.array(z.array(z.number())),
});

export const lineStringSchema = z.object({
  type: z.literal("LineString"),
  coordinates: z.array(z.array(z.number())),
});

export const polygonSchema = z.object({
  type: z.literal("Polygon"),
  coordinates: z.array(z.array(z.array(z.number()))),
});

export const multiPolygonSchema = z.object({
  type: z.literal("MultiPolygon"),
  coordinates: z.array(z.array(z.array(z.array(z.number())))),
});

export const multiLineStringSchema = z.object({
  type: z.literal("MultiLineString"),
  coordinates: z.array(z.array(z.array(z.number()))),
});

export const geometryCollectionSchema = z.object({
  type: z.literal("GeometryCollection"),
  geometries: z.array(
    z.discriminatedUnion("type", [
      /* Without recursively including geometry collection itself. */
      pointSchema,
      multiPointSchema,
      lineStringSchema,
      polygonSchema,
      multiLineStringSchema,
      multiPolygonSchema,
      z.object({
        type: z.literal("GeometryCollection"),
        /* This has to be here still to make the geojson library's Geometry type
         compatible with the type inferred from this schema. Sigh. */
        geometries: z.array(z.any()),
      }),
    ])
  ),
});

export const geometrySchema = z.discriminatedUnion("type", [
  pointSchema,
  multiPointSchema,
  lineStringSchema,
  polygonSchema,
  multiLineStringSchema,
  multiPolygonSchema,
  geometryCollectionSchema,
]);
export type Geometry = z.infer<typeof geometrySchema>;

export const featureSchema = z.object({
  type: z.literal("Feature"),
  geometry: geometrySchema,
  properties: z.record(z.string(), z.any()).optional(),
});

export const featureCollectionSchema = z.object({
  type: z.literal("FeatureCollection"),
  features: z.array(featureSchema),
});

export type FeatureCollection = z.infer<typeof featureCollectionSchema>;
